export var truncate = function (s, length) {
    if (length < 0) {
        return s;
    }
    return s.slice(0, length);
};
export var substituteWhitespace = function (s) { return s.replace(/\s/g, "-"); };
export var normalise = function (s, length) {
    return truncate(substituteWhitespace(s), length);
};
var formValidators = {
    // Check validation for each individual field and show an error popup flag if it's invalid
    organization: function (value, showFlag) {
        if (!value || value === "Accounting") {
            var message = "Organization must not be empty";
            showFlag({
                type: "error",
                title: "Error",
                message: message,
            });
            return message;
        }
        return undefined;
    },
    owner: function (value, showFlag) {
        if (!value) {
            var message = "Owner must not be empty";
            showFlag({
                type: "error",
                title: "Error",
                message: message,
            });
            return message;
        }
        return undefined;
    },
    source_id: function (value, showFlag) {
        // source_id it undefined on render so we only check for null
        if (value === undefined) {
            return undefined;
        }
        if (!value) {
            var message = "Source ID must not be empty";
            showFlag({
                type: "error",
                title: "Error",
                message: message,
            });
            return message;
        }
        if (value.length > 64) {
            var message = "Source ID must not exceed 64 characters";
            showFlag({
                type: "error",
                title: "Error",
                message: message,
            });
            return message;
        }
        if (!/^[a-z0-9-]+$/i.test(value)) {
            var message = "Source ID should only contain characters, numbers or dashes";
            showFlag({
                type: "error",
                title: "Error",
                message: message,
            });
            return message;
        }
        return undefined;
    },
    admins: function (value, showFlag) {
        if (/^\s+/.test(value)) {
            var message = "Admin Group should not have leading white space";
            showFlag({
                type: "error",
                title: "Error",
                message: message,
            });
            return message;
        }
        if (/\s+$/.test(value)) {
            var message = "Admin Group should not have trailing white space";
            showFlag({
                type: "error",
                title: "Error",
                message: message,
            });
            return message;
        }
        return undefined;
    },
    acl: {
        environments: function (value, showFlag) {
            if (!value) {
                var message = "Environments must not be empty";
                showFlag({
                    type: "error",
                    title: "Error",
                    message: message,
                });
                return message;
            }
            return undefined;
        },
        staffid_group: function (value, showFlag) {
            if (!value) {
                var message = "StaffID groups must not be empty";
                showFlag({
                    type: "error",
                    title: "Error",
                    message: message,
                });
                return message;
            }
            return undefined;
        },
    },
};
export default formValidators;
